<div pias-layout-content>
  @if(this.setSprinner()) {
  <div class="pias-spinner">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }
  <div class="content">
    <div class="individual-rep-container container-fluid" [formGroup]="repassessment">
      <div class="table-container">
        <div class="page-header">
          <h5 class="page-title">REPRESENTATIVE ASSESSMENT ({{role}})</h5>
        </div>

        <div class="row g-3">

          <!-- Representative Name -->
          <div class="col-md-6">
            <mat-label class="field-label">Name of Representative</mat-label>
            <mat-form-field class="w-100">
              <input matInput type="text" formControlName="repName" readonly>
            </mat-form-field>
          </div>

          <!-- PIAS Rep Code -->
          <div class="col-md-6">
            <mat-label class="field-label">PIAS Rep Code</mat-label>
            <mat-form-field class="w-100">
              <input matInput type="text" formControlName="repCode" readonly>
            </mat-form-field>
          </div>

          <!-- Branch -->
          <div class="col-md-6">
            <mat-label class="field-label">Branch</mat-label>
            <mat-form-field class="w-100">
              <input matInput type="text" formControlName="branch" readonly>
            </mat-form-field>
          </div>

          <!-- Date of Interview -->
          <div class="col-md-6">
            <mat-label class="field-label">Date of interview</mat-label>

            <mat-form-field class="w-100">
              <input matInput formControlName="interviewDate" placeholder="Enter Date of Interview"
                [matDatepicker]="picker" />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              @if(this.repassessment.controls["interviewDate"].invalid
              && (this.repassessment.controls["interviewDate"].touched ||
              this.repassessment.controls["interviewDate"].dirty)
              ) {
              <mat-error>
                <span>{{message}}</span>
              </mat-error>
              }
            </mat-form-field>
          </div>

          <!-- Basis of recommendations -->
          <div class="col-md-12">
            <mat-label class="field-label">
              Basis of recommendations in engaging the Introducer
            </mat-label>

            <mat-form-field class="w-100">
              <textarea class="info-field" matInput type="text" formControlName="basicRecommendations"
                placeholder="Enter Basis of recommendations" required></textarea>
              @if(this.repassessment.controls["basicRecommendations"].invalid
              && (this.repassessment.controls["basicRecommendations"].touched ||
              this.repassessment.controls["basicRecommendations"].dirty)
              ) {
              <mat-error>
                @if(this.repassessment.controls["basicRecommendations"].errors?.["required"]) {
                <span>{{message}}</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }
            </mat-form-field>
          </div>

          <!-- Commission Split: -->
          <h5 class="field-title">Commission Split</h5>
          <!-- Representative -->
          <div class="col-md-6">
            <mat-label class="field-label">
              <!-- <mat-icon class="label-icon">supervisor_account</mat-icon> -->
              Representative
            </mat-label>

            <mat-form-field class="w-100">
              <input matInput type="number" formControlName="representative"
                placeholder="Enter Representative Commission">
              <mat-icon matSuffix>percent</mat-icon>
              @if(this.repassessment.controls["representative"].invalid
              && (this.repassessment.controls["representative"].touched ||
              this.repassessment.controls["representative"].dirty)
              ) {
              <mat-error>
                @if(this.repassessment.controls["representative"].errors?.["required"]) {
                <span>{{message}}</span>
                }@else if (this.repassessment.controls["representative"].errors?.["min"] ||
                this.repassessment.controls["representative"].errors?.["max"]) {
                <span> Percentage must be between 0 and 100.</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }
            </mat-form-field>
          </div>
          <!-- Introducer -->
          <div class="col-md-6">
            <mat-label class="field-label">
              <!-- <mat-icon class="label-icon">supervisor_account</mat-icon> -->
              Introducer
            </mat-label>

            <mat-form-field class="w-100">
              <input matInput type="number" formControlName="introducer" placeholder="Enter Introducer Commission">
              <mat-icon matSuffix>percent</mat-icon>
              @if(this.repassessment.controls["introducer"].invalid
              && (this.repassessment.controls["introducer"].touched ||
              this.repassessment.controls["introducer"].dirty)
              ) {
              <mat-error>
                @if(this.repassessment.controls["introducer"].errors?.["required"]) {
                <span>{{message}}</span>
                }@else if (this.repassessment.controls["introducer"].errors?.["min"] ||
                this.repassessment.controls["introducer"].errors?.["max"]) {
                <span>Percentage must be between 0 and 100.</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }
            </mat-form-field>
          </div>
          @if (this.repassessment.errors?.['splitPercentage']) {
          <mat-error>
            <span>Total commission split percentage must equal 100%.</span>
          </mat-error>
          }
        </div>
        @if( (this.status === 'Rectification')){
        <h5 class="field-title">Rectification Attachments</h5>
        <div formArrayName="rectificationAttachemnts">
          @for (item of rectificationAttachemnts.controls; track $index; let i = $index) {
          <div class="row align-items-center" [formGroupName]="i">
            <div class="col-md-6">
              <label class="field-label">Attachment Name</label>
              <mat-form-field class="w-100">
                <mat-select matInput formControlName="categoryName" placeholder="Select Attachment Name">
                  @for(categoryname of this.documentCategorynames; track categoryname) {
                  <mat-option value="{{categoryname.name}}">{{categoryname.name}}</mat-option>
                  }

                </mat-select>
                @let categoryNameControl = item.get('categoryName');
                @if(categoryNameControl?.invalid && (categoryNameControl?.touched || categoryNameControl?.dirty)) {
                <mat-error>
                  @if(categoryNameControl?.errors?.["required"]) {
                  <span>{{message}}</span>
                  }
                  @else {
                  <span></span>
                  }
                </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-md-6 d-flex flex-column align-items-end">
              @let documentFilename = item.get('documentFilename');
              @if(isReadOnly() == false){
              <!-- Upload Button -->
              <label class="upload-btn" *ngIf="!documentFilename?.value">
                Upload Document

                <input type="file" id="documentFilename" accept=".pdf,.jpg,.jpeg,.png" hidden
                  (change)="onDocumentFileChange($event,i)" />
              </label>
              }
              <input type="text" formControlName="documentFilename" hidden>

              @if (documentFilename?.value) {
              <!-- Uploaded File Name -->
              <div class="file-container" *ngIf="documentFilename?.value">
                @if(isReadOnly() == false){
                <span class="file-name">{{
                  documentFilename?.value
                  }}</span>

                <button mat-icon-button color="warn" class="delete-btn"
                  (click)="removeFile('documentFilename','document',i)">✖</button>
                }
              </div>
              }

              @if(isReadOnly() == true){
              @let category = item.get('categoryName')?.value;
              @if(documentFilename?.value == ''){
              <button mat-stroked-button [disabled]="true">
                N/A
              </button>
              }@else{
              <button mat-stroked-button (click)="previewDoc(category,i)">
                View
              </button>
              }
              }
              @if(documentFilename?.invalid && (documentFilename?.touched || documentFilename?.dirty)) {
              <mat-error>
                @if(documentFilename?.errors?.["required"]) {
                <span class="w-100 text-end">{{message}}</span>
                }
                @else if(documentFilename?.errors?.['invalidType']){
                <span class="w-100 text-start">Only PDF, JPG, PNG files are allowed.</span>
                }
                @else if(documentFilename?.errors?.['maxSize']){
                <span class="w-100 text-start">File size must be less than or equal to 5MB.</span>
                }
                @else {
                <span></span>
                }
              </mat-error>
              }
            </div>
          </div>
          <!-- Delete -->
          <div class="col-md-3 text-end">
            @if (rectificationAttachemnts.length > 1 && isReadOnly() == false) {
            <button mat-stroked-button color="warn" type="button"
              (click)="removeRow(i)"><mat-icon>delete</mat-icon>Delete
              Attachment</button>
            }
          </div>
          }
          @if(isReadOnly() === false){
          <!-- Add Button -->
          <div class="text-end mt-3">
            <button mat-stroked-button color="primary" type="button" (click)="addRow()">
              + Add Attachment
            </button>
          </div>
          }
        </div>
        <div class="col-md-12">
          <mat-label class="field-label">
            Rectification recommendations in engaging the Introducer
          </mat-label>

          <mat-form-field class="w-100">
            <textarea class="info-field" matInput type="text" formControlName="rectificationRecommendations"
              placeholder="Enter RectificationRecommendations"></textarea>
          </mat-form-field>
        </div>
        }

        <!-- Other Attachments -->
        <div class="section-card other-attachments-card">
          <div class="section-header">
            <mat-icon>attach_file</mat-icon>
            <span>Other Attachments</span>
          </div>
          <div class="container-fluid">
            <div class="row g-3">
              @for(key of otherAttachmentKeys; track key){
              <div class="col-md-6">
                <div class="upload-container">
                  <div class="upload-box">
                    <input type="file" [disabled]="isReadOnly()"  [id]="key + 'fileName'" accept=".pdf,.jpg,.jpeg,.png"
                      (change)="onOtherAttachmentFileChange($event, key)">
                    <input type="text" [formControlName]="key + 'fileName'" hidden>

                    <!-- Show filename OR placeholder -->
                    @if(!this.repassessment.get(key + 'fileName')?.value){
                    <span>
                      Choose file
                    </span>
                    }
                    @if(this.repassessment.get(key + 'fileName')?.value){
                    <div class="attachment-row">
                      <span class="file-name">
                        {{ this.repassessment.get(key + 'fileName')?.value }}
                      </span>
                      @if(isReadOnly() === false){
                      <button mat-icon-button color="primary" class="delete-btn"
                        (click)="removeOtherAttachmentFile(key)">
                        <mat-icon>close</mat-icon>
                      </button>
                      }
                      <button mat-icon-button color="primary" class="delete-btn" (click)="previewAttachment(key, key + 'fileName')">
                      <mat-icon>visibility</mat-icon>
                      </button>
                    </div>
                    }
                  </div>
                  @if(isReadOnly() === false){
                  @if(!$first){
                  @if(!this.repassessment.get(key + 'fileName')?.value){  
                  <button type="button" class="icon-btn row-action-btn remove-attachment-btn"
                    matTooltip="Remove this attachment field" (click)="removeOtherAttachment(key)">
                    <mat-icon>close</mat-icon>
                  </button>
                  }
                  }
                  @if($last){
                  <button type="button" class="icon-btn row-action-btn add-attachment-btn"
                    matTooltip="Add another attachment" (click)="addOtherAttachment()">
                    <mat-icon>add</mat-icon>
                  </button>
                  }
                  }
                </div>
                @if(this.repassessment.get(key + 'fileName')?.invalid
                && (this.repassessment.get(key + 'fileName')?.touched ||
                this.repassessment.get(key + 'fileName')?.dirty)
                ) {
                <mat-error>
                  @if(this.repassessment.get(key + 'fileName')?.errors?.['invalidType']){
                  <span>Only PDF, JPG, PNG files are allowed.</span>
                  }
                  @else if(this.repassessment.get(key + 'fileName')?.errors?.['maxSize']){
                  <span>File size must be less than or equal to 5MB.</span>
                  }
                  @else {
                  <span></span>
                  }
                </mat-error>
                }
              </div>
              }
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mt-3">
            <mat-checkbox formControlName="declarationaccepted">I agree to the above
              declaration.</mat-checkbox>
            @if(this.repassessment.controls["declarationaccepted"].invalid
            && (this.repassessment.controls["declarationaccepted"].touched ||
            this.repassessment.controls["declarationaccepted"].dirty)
            ) {
            <mat-error>
              @if(this.repassessment.controls["declarationaccepted"].errors?.["required"]) {
              <span>{{message}}</span>
              }
              @else {
              <span></span>
              }
            </mat-error>
            }
          </div>
          <div class="col-md-6">
            <mat-label class="field-label">Representative Name</mat-label>
            <mat-form-field class="w-100 custom-form-field">
              <input matInput formControlName="decleredrepName" readonly />
            </mat-form-field>
          </div>

          <div class="col-md-6">
            <mat-label class="field-label">Date</mat-label>
            <mat-form-field class="w-100 custom-form-field">
              <input type="date" matInput formControlName="date" readonly />
            </mat-form-field>
          </div>
        </div>
        @if(this.errormessage != ''){
        <mat-error>

          <span>{{errormessage}}</span>
        </mat-error>
        }
      </div>
      @if(isReadOnly() == false){
      <!-- Form Actions -->
      <div class="form-actions">
        @if(this.status != 'Rectification'){
        <button class="save-btn  me-2" (click)="returnByRole()">
          <mat-icon>arrow_backward</mat-icon>
          <span>Return to Candidate</span>
        </button>
        }
        <button class="save-btn" (click)="saveAndContinue()">
          <span>Save</span>
        </button>
        <button class="save-btn" (click)="openConfirmDialog()" [disabled]="repassessment.invalid">
          <span>Submit</span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
      }
    </div>
  </div>
  @if (showPreview) {
  <div class="preview-backdrop" appDocumentPreviewOverlay (dismiss)="closePreview()">
    <div class="preview-panel" role="dialog" aria-modal="true" aria-label="Document preview">

      <div class="preview-header d-flex justify-content-between align-items-center p-3 border-bottom">
        <div class="d-flex flex-column">
          <span class="fw-bold fs-5">Document Preview</span>
          <small class="text-muted">{{ currentFileName }}</small>
        </div>
        <div class="preview-header-actions">
          @if (!isPdf) {
          <button mat-icon-button (click)="zoomOut()" [disabled]="zoomLevel <= MIN_ZOOM" title="Zoom out">
            <mat-icon>zoom_out</mat-icon>
          </button>
          <span class="zoom-level">{{ zoomLevel * 100 }}%</span>
          <button mat-icon-button (click)="zoomIn()" [disabled]="zoomLevel >= MAX_ZOOM" title="Zoom in">
            <mat-icon>zoom_in</mat-icon>
          </button>
          }
          <button mat-icon-button color="warn" (click)="closePreview()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <!-- Preview Content -->
      <div class="preview-content">
        @if (isPdf) {
        <!-- <embed [src]="pdfUrl"  width="100%" height="600px" /> -->
        <iframe [src]="selectedDocument" width="100%" height="100%"></iframe>

        } @else {
        <img [src]="selectedDocument" alt="Document Preview" class="preview-image"
          [style.transform]="'scale(' + zoomLevel + ')'" />
        }
      </div>

    </div>
  </div>
  }
</div>